// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArTeF9qEyQ_0ApwfBuxOCQhGbo-fohLy0",
  authDomain: "plants-5f51e.firebaseapp.com",
  projectId: "plants-5f51e",
  storageBucket: "plants-5f51e.appspot.com",
  messagingSenderId: "867733442805",
  appId: "1:867733442805:web:a7cfd6d54c59417b3975bc",
  measurementId: "G-3C1BSVF8BQ",
};

const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Use initializeFirestore (not getFirestore) so we can opt into long-polling
// auto-detection. Firestore's default streaming (WebChannel) transport often
// can't hold its connection open on mobile networks / browsers / proxies, so
// onSnapshot updates queue and then flush in a burst — realtime games feel
// like they freeze then jump. Auto-detect probes the link and falls back to
// long-polling only when streaming is unreliable, so laptops keep the fast
// stream and mobile gets prompt updates. Must run before any getFirestore()
// call elsewhere — this module is the single place that creates `db`.
export default initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
